import * as React from 'react';
import { useForm } from 'react-final-form';
import { useEffect } from 'react';
import { FieldsMap } from '../../../../Passenger/types';

interface Props {
	fieldsMap: FieldsMap;
	disabled?: boolean;
}

const WindowScope: React.FC<Props> = props => {
	const form = useForm();

	const changePassengerField = (fieldName: string, passengerId: number, newValue: string) => {
		if (props.fieldsMap.hasOwnProperty(fieldName) && !props.fieldsMap[fieldName].readonly && !props.disabled) {
			form.change(`passengers[${passengerId}].[${fieldName}]`, newValue);

			return true;
		}

		return false;
	};

	useEffect(() => {
		(window as any).changePassengerField = changePassengerField;

		return () => {
			(window as any).changePassengerField = null;
		};
	}, []);

	return <>{props.children}</>;
};

export default WindowScope;
